export var ONBOARDING_STORAGE_VERSION = 'v2';
export var TOUR_IDS = [
    'reservation',
    'package',
    'patientHistory',
    'patientProfile',
    'appointment',
    'patientLog',
    'inventory',
    'financial',
];
export var TOUR_ROUTES = {
    reservation: '/reservation-packages',
    package: '/packages',
    patientHistory: '/patients',
    appointment: '/appointments',
    inventory: '/stock_movements',
    financial: '/transactions',
};
export var isPatientProfilePath = function (pathname) {
    return /^\/patients\/\d+$/.test(pathname);
};
export var isShowAppointmentPath = function (pathname) {
    return /^\/appointments\/\d+$/.test(pathname);
};
